
export const environment = {
  production: false,
  frontendapp:'https://app.cerouzisha.com',
  offlinenodeserver:'https://prod.uzisha.api.cerouzisha.com:3000',
  offlinesocketserver:'https://prod.uzisha.api.cerouzisha.com:3000',
  laravelServerUrl:'https://prod.uzisha.api.cerouzisha.com:8000',
  laravelServerApiUrl:'https://prod.uzisha.api.cerouzisha.com:8000/api',
  laravelSrcImgUrl:'https://prod.uzisha.api.cerouzisha.com:8000/storage/app/public/',
  laravelImgUrl:'https://prod.uzisha.api.cerouzisha.com:8000/app/uploads/',
  laravelUrlImgUpload:'https://prod.uzisha.api.cerouzisha.com:8000/app/upload.php',
};

